import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2"; // Import the Bar chart component
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { useGlobalContext } from "../../component/GlobalContext";
import { HTTP } from "../../api/http-common";
import { faker } from '@faker-js/faker';
import { Link, useNavigate } from "react-router-dom";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function AdminDashboard() {
  const { globalUserVar, fetchCoupons, fetchVendors, fetchUsers } = useGlobalContext();
  const access_token = (localStorage.getItem('access_token'));
  const [roleId, setRoleId] = useState("1");
  const [totalCoupons, setTotalCoupons] = useState(0);
  const [totalVendors, setTotalVendors] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [dataSet, setDataSet] = useState([]);
  const [activeVendorsData, setActiveVendorsData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Active Vendors',
        data: [],
        backgroundColor: 'rgba(75, 192, 192, 0.5)', // Set a background color for bars
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  });
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
  const labels = ['Vendors', 'Members'];
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Users Chart',
      },
    },
  };
  //   console.log(labels.map(() => faker.datatype.number({ min: 0, max: 1000 })))
  const data = {
    labels,
    datasets: dataSet
    // datasets: [
    //   {
    //     label: 'Dataset 1',
    //     data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
    //     backgroundColor: 'rgba(255, 99, 132, 0.5)',
    //   },
    //   {
    //     label: 'Dataset 2',
    //     data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
    //     backgroundColor: 'rgba(53, 162, 235, 0.5)',
    //   },
    // ],

  };
  //   console.log(data.datasets)
  // const datasetsQ = [
  //   {
  //     label: 'Dataset 1',
  //     data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
  //     backgroundColor: 'rgba(255, 99, 132, 0.5)',
  //   },
  //   {
  //     label: 'Dataset 2',
  //     data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
  //     backgroundColor: 'rgba(53, 162, 235, 0.5)',
  //   },
  // ]
  // console.log(datasetsQ)

  useEffect(() => {
    let userData;
    if (typeof globalUserVar === "string") {
      userData = JSON.parse(globalUserVar); // Parse the JSON string
      setRoleId(userData.role_id);
      loadDashboard();
    }
  }, [globalUserVar]);

  const loadDashboard = async () => {
    let config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    }
    let fields = {

    };
    HTTP.post('user/dashboard', fields, config)
      .then((response) => {
        // console.log(response)
        const data = response.data;
        if (response.status === 200) {
          setTotalCoupons(data.total_count_coupons);
          setTotalVendors(data.total_count_vendors);
          setTotalUsers(data.total_count_member);
          setDataSet(data.bar_chart_dataset);
        }
        if (response.status === 204) {
          // setAaMasters([])
        }
      })
      .catch((error) => {
        console.log(error)
        // setRerenderFlag(true);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  };
  return (
    <>
      <div className="custom-dashboard-container">
        {/* <div className="custom-dashboard-header">
                <h1>Dashboard</h1>
                <p>Role ID: {roleId}</p>
            </div> */}

        <div className="custom-dashboard-stats">

          <div className="custom-stat-card">
            <Link to="/coupons">
              <h2>{totalCoupons}</h2>
              <p>Total Coupons</p>
            </Link>
          </div>

          <div className="custom-stat-card">
            <Link to="/vendors">
              <h2>{totalVendors}</h2>
              <p>Total Vendors</p>
            </Link>
          </div>
          <div className="custom-stat-card">
            <Link to="/members">
              <h2>{totalUsers}</h2>
              <p>Total Members</p>
            </Link>
          </div>
        </div>
        <br />

        <div className="custom-dashboard-graph">
          <Bar options={options} data={data} />
          {/* <p>Active Vendors Bar Chart (Verification Status 1)</p>
          {activeVendorsData.labels.length === 0 ? (
            <p>No approved vendors available for the graph.</p>
          ) : (
            <Bar data={activeVendorsData} />
          )} */}
        </div>
      </div>
    </>
  )
}

export default AdminDashboard